import _ from 'lodash';
import extractDomain from './utils/extractDomain';
import { addClassList } from './utils/addClassList';
import { appendToParent, prependChild } from './utils/appendToParent';
import { createElement } from './utils/createElement';
import { getAttributes } from './utils/getAttributes';
import getFirstSiblingWithClass from './utils/getFirstSiblingWithClass';
import loaderImg from '../src/assets/loader.gif';
let autopopTriggered = false;

class mycreditdrive {
  constructor({
    parentWebSite = '',
    utmParams = null,
    classList = '',
    buttonImgurl = '',
    subTitle = '',
    colorPrimary,
    colorSecondary,
    infoSectionBackground,
    url = 'http://localhost:3000/',
    title = 'Launch Button',
    parentDiv,
    isModal = false,
    buyyerElement,
    mycreditdriveInputs = {},
    customerDetails = {},
    innerHTML = 'widget button',
    createIframe = true,
    buttonPrimary = '',
    buttonSecondary = '',
    apiparam,
    dcv,
    rpl,
    cdsid,
    voistock,
    voiyear,
    voimake,
    voimodel,
    voitrim,
    voiused,
    Formid,
    vin,
    gtmid,
    lowestonly,
    template,
    additionalParams,
    pic,
    mainmessage,
    validationMessage,
    NoPaymentSuccessMessage,
    disclaimer,
    odometer,
    purchase,
    msrp,
    downpayment,
  } = {}) {
    this.parentWebSite = parentWebSite;
    this.buttonPrimary = buttonPrimary;
    this.buttonSecondary = buttonSecondary;
    this.buttonImgurl = buttonImgurl;
    this.innerHTML = innerHTML;
    this.customerDetails = customerDetails;
    this.colorPrimary = colorPrimary;
    this.apiparam = apiparam;
    this.dcv = dcv;
    this.rpl = rpl;
    this.cdsid = cdsid;
    this.voistock = voistock;
    this.voiyear = voiyear;
    this.voimake = voimake;
    this.voimodel = voimodel;
    this.voitrim = voitrim;
    this.voiused = voiused;
    this.Formid = Formid;
    this.vin = vin;
    this.lowestonly = lowestonly;
    this.template = template;
    this.additionalParams = additionalParams;
    this.pic = pic;
    this.mainmessage = mainmessage;
    this.validationMessage = validationMessage;
    this.NoPaymentSuccessMessage = NoPaymentSuccessMessage;
    this.disclaimer = disclaimer;
    this.odometer = odometer;
    this.purchase = purchase;
    this.msrp = msrp;
    this.downpayment = downpayment;
    this.colorSecondary = colorSecondary;
    this.utmParams = utmParams;
    this.infoSectionBackground = infoSectionBackground;
    this.isModal = isModal;
    this.gtmid = gtmid;
    this.url = url;
    this.classes = classList;
    this.lauchButton = buyyerElement;
    this.buttonTitle = title;
    this.buttonSubTitle = subTitle;
    this.open = false;
    this.parentDiv = parentDiv;
    this.mycreditdriveInputs = mycreditdriveInputs;
    this.titleContainer = null;
    this.buttonFallBacktitleContainer = null;
    this.iWindow = null;
    this.createIframe = createIframe;
    this.iframeContainer = null;
    this.imgContainer = null;
    this.initialize();
  }
  // Initializing
  initialize() {
    if (this.createIframe) {
      // Creating Container for Iframe
      this.iframeContainer = createElement('div');
      addClassList(this.iframeContainer, [
        'cta__mycreditdrive__modalLaunch__hidden',
        'cta__mycreditdrive__modalLaunch__modal_container',
      ]);

      // Creating Iframe
      this.iframe = createElement('iframe');
      addClassList(
        this.iframe,
        'cta__mycreditdrive__modalLaunch__modal_container_iframe',
      );

      const isMobile = /Mobi|Android/i.test(navigator.userAgent);
      if (this.isModal === 'false' && isMobile) {
        this.iframe.style.height = '95vh';
        this.iframe.style.width = '100%';
      }

      //OF-1600 & 1619
      //pull in value for template and switch url of form.
      //this.iframe.src = this.url; //url of the widget modal
      const guidMap = new Map([
        ["550e8400-e29b-41d4-a716-446655440000", 1],
        ["3f2504e0-4f89-41d3-9a0c-0305e82c3301", 2],
        ["6ba7b810-9dad-11d1-80b4-00c04fd430c8", 3],
        ["9bdbb4a0-5c42-4b79-bd53-8903fa0e7d53", 4],
        ["a17fc4d0-48c3-4c6f-bf80-6f3d7f52e2b8", 5],
        ["b4c38d0a-69f3-49d6-9b61-0ad1a8fcfd74", 6],
        ["cfc693e0-7d3b-4b34-9c32-f9902a68d8b4", 7],
        ["e2c02d7a-39b8-4203-b9c4-09e38f3b4e6a", 8],
        ["f8b6cc02-5a1d-40d1-a1c6-285b679e6c9a", 9],
        ["0263e013-1a2c-4d68-b995-b68d9b1e19b2", 10],
        ["13e7cf10-6bf1-4905-8a74-8c16b4edb0ae", 11],
        ["2f5a0f9d-bb41-4a8a-bf3b-3a234a1161e4", 12],
        ["38d456f8-5b28-4d7a-98a1-048b2c9470dc", 13],
        ["4eac8c5a-3b73-4f8f-812d-69d37e6dc34f", 14],
        ["5c9a4b37-b0cf-46f9-91e4-3a1fa46e3a1d", 15],
        ["6717bfb9-23fc-49aa-a9ec-0cc1f4ffb981", 16],
        ["72eb8bc3-1db8-42a3-98b6-3e5d4f68d6a4", 17],
        ["889a26b4-86d1-46c6-b8b8-d50eb4377b7e", 18],
        ["9f3f89df-7e56-42a9-92e1-8ea5f9f3cde9", 19],
        ["a64b0e60-2907-4b56-94c3-d72d058c5e10", 20]
      ]);
    
      function getTemplateNumber(guid) {
          return guidMap.get(guid) || ''; //Default to 1 if GUID is not found
      }

      const templateNumber = getTemplateNumber(this.template);

      const templateFile = templateNumber ? `index${templateNumber}.html` : 'index.html';
      this.url = this.url.replace('index.html', templateFile);
      this.iframe.src = this.url;

      this.iframe.style.opacity = 0;
      this.iframe.setAttribute('allowTransparency', 'true');
      this.iframe.setAttribute('background', 'transparent');
      this.iframe.setAttribute('title', 'OfferLogix');

    }
    //Adding additional classes to button
    _.forEach(this.classes ? this.classes.split(' ') : [], (item) =>
      addClassList(this.lauchButton, item),
    );

    //If its a button trigering modal
    if (this.isModal === 'true') {
      if (this.createIframe) {
        document.body.append(this.iframeContainer);
      }
      //Disbale the button initially
      this.lauchButton.disabled = true;

      //Add additional classes to button
      addClassList(
        this.lauchButton,
        'cta__mycreditdrive__modalLaunch_buttonLaunch',
      );

      //Create fallback container for title to be placed inside button when iframe is not yet loaded
      this.buttonFallBacktitleContainer = createElement('div');
      addClassList(
        this.buttonFallBacktitleContainer,
        'cta__mycreditdrive_titlecontainer',
      );
      this.fallbacktitle = createElement('span');
      addClassList(this.fallbacktitle, 'loader-g');
      this.fallbacktitle.src = loaderImg;
      appendToParent(this.buttonFallBacktitleContainer, this.fallbacktitle);
      appendToParent(this.lauchButton, this.buttonFallBacktitleContainer);
      if (this.buttonPrimary) {
        document.documentElement.style.setProperty(
          '--primaryctabutton',
          this.buttonPrimary,
        );
        // debugger;
        // this.lauchButton.style.backgroundColor = this.buttonPrimary;
      }
      if (this.buttonSecondary) {
        document.documentElement.style.setProperty(
          '--secondaryctabutton',
          this.buttonSecondary,
        );
      }

      //Add Launch button to DOM to the parent element
      appendToParent(this.parentDiv, this.lauchButton);

      //Add listner to button onclick
      this.lauchButton.addEventListener('click', this.modalOpen.bind(this));
    } else {
      this.iframeContainer.classList.remove(
        'cta__mycreditdrive__modalLaunch__modal_container',
      );

      addClassList(this.iframeContainer, 'cta__mycreditdrive__modalLaunch__screen');
      addClassList(
        this.lauchButton,
        'cta__mycreditdrive__modalLaunch_isModal_false',
      );

      appendToParent(this.lauchButton, this.iframeContainer);

      this.iframe.addEventListener('load', () => {
        //Code to be executed after the iframe has loaded
        this.iframe.style.opacity = 1;
        this.iframeContainer.classList.remove(
          'cta__mycreditdrive__modalLaunch__hidden',
        );
      });
    }

    if (this.createIframe) {
      this.iframe.addEventListener('load', () => {
        const lauchButtonsTitleContainers = document.querySelectorAll(
          '.cta__mycreditdrive_titlecontainer',
        );
        if (this.isModal === 'false') {
          this.iWindow = this.iframe.contentWindow;
          this.modalOpen.call(this);
        }
        if (
          this.isModal === 'true' &&
          lauchButtonsTitleContainers instanceof NodeList &&
          lauchButtonsTitleContainers.length > 0
        ) {
          lauchButtonsTitleContainers.forEach((lauchButtonsTitleContainer) => {
            // this.iWindow = this.iframe.contentWindow;
            const parentNode = lauchButtonsTitleContainer.parentNode; // Which is the button
            const childElementToRemove = parentNode.childNodes[0]; // Replace 'childClass' with the class name of the element you want to remove
            // Check if the child element was found
            if (childElementToRemove) {
              // Remove the child element from the parent
              parentNode.removeChild(childElementToRemove);
            }

            const wrapperElement = getFirstSiblingWithClass(
              parentNode,
              'cta__mycreditdrive__modalLaunch',
            );
            let buttonTitle = getAttributes(wrapperElement, 'title');
            let buttonsubTitle = getAttributes(wrapperElement, 'subTitle');
            let buttonImageUrl = getAttributes(
              wrapperElement,
              'button-img-url',
            );
            // Create container for title to be placed inside button
            this.titleContainer = createElement('div');
            addClassList(this.titleContainer, 'cta__mycreditdrive_titlecontainer');
            this.title = createElement('h4');
            this.title.textContent = buttonTitle;
            appendToParent(this.titleContainer, this.title);
            this.subTitle = createElement('h6');
            this.subTitle.textContent = buttonsubTitle;
            appendToParent(this.titleContainer, this.subTitle);
            appendToParent(parentNode, this.titleContainer);
            // Add image to launch button if any
            if (buttonImageUrl && buttonImageUrl.trim() !== '') {
              this.imgContainer = createElement('div');
              addClassList(this.imgContainer, 'cta__mycreditdrive_imgContainer');
              this.img = createElement('img');
              this.img.src = buttonImageUrl;
              appendToParent(this.imgContainer, this.img);
              appendToParent(parentNode, this.imgContainer);
            }            
            parentNode.disabled = false;
          });
        }
        //OF-1827 auto pop open modal
        const urlParams = new URLSearchParams(window.location.search);
        if (
          ['1', 'true'].includes(urlParams.get('autopop_preapp')) &&
          this.isModal === 'true' &&
          !autopopTriggered
        ) {
          autopopTriggered = true;
          setTimeout(() => this.modalOpen(), 100);
        }
      });
    }
    if (
      (this.isModal === 'true' && this.createIframe) ||
      this.isModal === 'false'
    ) {
      appendToParent(this.iframeContainer, this.iframe);
    }

    // Listening to child iframe communications (only from our widget iframes)
    function handleMessage(event) {
      const frames = Array.from(
        document.getElementsByClassName('cta__mycreditdrive__modalLaunch__modal_container_iframe')
      );

      // Must come from one of our iframes
      const senderIframe = frames.find(f => f.contentWindow === event.source);
      if (!senderIframe) {
        // Not from our iframe — ignore quietly
        return;
      }

      // Origin must match that iframe's src origin
      let iframeOrigin = '';
      try {
        const rawSrc = senderIframe.getAttribute('src') || '';
        if (!rawSrc) return;
        iframeOrigin = new URL(rawSrc, window.location.href).origin;
      } catch {
        return;
      }
      if (event.origin !== iframeOrigin) {
        // Wrong origin for this iframe — ignore
        return;
      }

      const msg = event.data;
      if (!msg || typeof msg !== 'object') return;

      if ('btnClose' in msg && typeof msg.btnClose === 'boolean') {
        const container = senderIframe.closest('.cta__mycreditdrive__modalLaunch__modal_container');
        if (container) {
          addClassList(container, 'cta__mycreditdrive__modalLaunch__hidden');
        }
      }
    }

    // Attach event listener
    window.addEventListener('message', handleMessage);

    // Ensure listener is removed when no longer needed
    window.addEventListener('beforeunload', () => {
      window.removeEventListener('message', handleMessage);
    });

  }

  //function for open the modal
  modalOpen() {
    //grab page type
    const pageType = window.asc_datalayer?.page_type || 'item';
    if (this.isModal === 'true') {
      // use *this* instance’s container & iframe, not the global ones
      const iframeContainer = this.iframeContainer;
      const childIframe      = this.iframe;
      const isOpen = !iframeContainer.classList.contains(
        'cta__mycreditdrive__modalLaunch__hidden',
      );
      const inputData = {
        isModal: this.isModal,
        gtmid: this.gtmid,
        customerDetails: this.customerDetails,
        infoSectionBackground: this.infoSectionBackground,
        colorPrimary: this.colorPrimary,
        buttonsecondary: this.buttonSecondary,
        buttonprimary: this.buttonPrimary,
        apiparam: this.apiparam,
        dcv: this.dcv,
        rpl: this.rpl,
        cdsid: this.cdsid,
        voistock: this.voistock,
        voiyear: this.voiyear,
        voimake: this.voimake,
        voimodel: this.voimodel,
        voitrim: this.voitrim,
        voiused: this.voiused,
        Formid: this.Formid,
        vin: this.vin,
        lowestonly: this.lowestonly,
        template: this.template,
        additionalParams: this.additionalParams,
        pic: this.pic,
        mainmessage: this.mainmessage,
        validationMessage: this.validationMessage,
        NoPaymentSuccessMessage: this.NoPaymentSuccessMessage,
        disclaimer: this.disclaimer,
        odometer: this.odometer,
        purchase: this.purchase,
        msrp: this.msrp,
        downpayment: this.downpayment,
        colorSecondary: this.colorSecondary,
        url: this.url,
        parentWebSite: this.parentWebSite,
        fromOrigin: true,
        utmParams: this.utmParams,
        page_type: pageType,
        ...this.mycreditdriveInputs,
      };

      const urlFormatted = this.url.replace(/\/+$/, '');
      if (!isOpen) {
        // OPEN: post the fresh data into this iframe
        childIframe.contentWindow.postMessage(inputData, urlFormatted);
        iframeContainer.classList.remove('cta__mycreditdrive__modalLaunch__hidden');
        childIframe.style.opacity = 1;
      } else {
        // CLOSE: hide & *fully* reload iframe (cache-buster) so GA4 can re-fire next time
        addClassList(iframeContainer, 'cta__mycreditdrive__modalLaunch__hidden');
        childIframe.style.opacity = 0;
        // append a timestamp param to force a hard reload and reset window state
        const cacheBustedUrl =
          this.url +
          (this.url.includes('?') ? '&' : '?') +
          '_cb=' +
          Date.now();
        childIframe.src = cacheBustedUrl;
      }
    } else {
      const iframeContainer = document.querySelector(
        '.cta__mycreditdrive__modalLaunch__screen',
      );
      const isOpen = false;
      const childIframe = document.getElementsByClassName(
        'cta__mycreditdrive__modalLaunch__modal_container_iframe',
      )[0];
      const inputData = {
        isModal: this.isModal,
        gtmid: this.gtmid,
        customerDetails: this.customerDetails,
        infoSectionBackground: this.infoSectionBackground,
        colorPrimary: this.colorPrimary,
        buttonsecondary: this.buttonSecondary,
        buttonprimary: this.buttonPrimary,
        apiparam: this.apiparam,
        dcv: this.dcv,
        rpl: this.rpl,
        cdsid: this.cdsid,
        voistock: this.voistock,
        voiyear: this.voiyear,
        voimake: this.voimake,
        voimodel: this.voimodel,
        voitrim: this.voitrim,
        voiused: this.voiused,
        Formid: this.Formid,
        vin: this.vin,
        lowestonly: this.lowestonly,
        template: this.template,
        additionalParams: this.additionalParams,
        pic: this.pic,
        mainmessage: this.mainmessage,
        validationMessage: this.validationMessage,
        NoPaymentSuccessMessage: this.NoPaymentSuccessMessage,
        disclaimer: this.disclaimer,
        odometer: this.odometer,
        purchase: this.purchase,
        msrp: this.msrp,
        downpayment: this.downpayment,
        colorSecondary: this.colorSecondary,
        buttonprimary: this.buttonPrimary,
        buttonsecondary: this.buttonSecondary,
        url: this.url,
        parentWebSite: this.parentWebSite,
        fromOrigin: true,
        utmParams: this.utmParams,
        ...this.mycreditdriveInputs,
      };

      const urlFormatted = this.url.replace(/\/+$/, '');
      if (!isOpen) {
        // childIframe.contentWindow.postMessage(inputData, window.location.origin);
        childIframe.contentWindow.postMessage(inputData, urlFormatted);
        // iframeContainer.classList.remove('cta__mycreditdrive__modalLaunch__hidden');
        childIframe.style.opacity = 1;
      }
    }
  }
}
function createStyles() {
  const styleTag = createElement('style');
  document.head.appendChild(styleTag);
  styleTag.innerHTML = `
    :root {
      --primaryctabutton: #13b85a;

      /* secondary color applicable for icon background */
      --secondaryctabutton: #13b85a2b;
    }
    .cta__mycreditdrive__modalLaunch_buttonLaunch {
      width:100%;
      min-height:70px;
      background-color: var(--primaryctabutton);
      border-radius: 8px;
      border-style: none;
      box-sizing: border-box;
      color: #FFFFFF;
      display: flex;
      flex-direction: row;
      cursor: pointer;
      font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
      font-size: 14px;
      font-weight: 500;
      line-height: 20px;
      list-style: none;
      margin: 0;
      outline: none;
      padding: 10px 16px;
      position: relative;
      text-align: center;
      text-decoration: none;
      transition: color 100ms;
      vertical-align: baseline;
      user-select: none;
      -webkit-user-select: none;
      touch-action: manipulation;  
    }
    .cta__mycreditdrive__modalLaunch_isModal_false{
      min-height:900px;
      display: flex;
    }
    @media (max-width: 576px) {
      .cta__mycreditdrive__modalLaunch_isModal_false{
        min-height:2050px;
        display: flex;
      }
    }
    .cta__mycreditdrive__modalLaunch_buttonLaunch:hover,
    .cta__mycreditdrive__modalLaunch_buttonLaunch:focus {
      background-color: var(--secondaryctabutton);
    }
   .cta__mycreditdrive_imgContainer {
    width: 30%;
    margin: auto;
    display: block;
   }
   .cta__mycreditdrive_titlecontainer {
    width: 100%;
    height: 100%;
    margin: auto;
    display: block;
    /*padding-right: 5%;*/
    justify-content: center;
    align-items: normal;
    text-align: left;
    flex-direction: column;
   }
   .cta__mycreditdrive_titlecontainer > h4 {
    margin: 0;
    padding: 0;
    font-weight: 800;
    color: #fff;
    font-size: 14px;
    text-align: center;
   }
   .cta__mycreditdrive_titlecontainer > h6 {
    margin: 0;
    padding: 0;
    font-weight: 500;
    font-size: 12px;
    line-height: 20px;
    color: #fff;
    text-align: center;
   }
   .loader-g {
    width: 35px;
    height: 35px;
    border-radius: 50%;
    position: relative;
    animation: rotate 1s linear infinite;
    display: inline-block;
  }
  .loader-g::before , .loader-g::after {
    content: "";
    box-sizing: border-box;
    position: absolute;
    inset: 0px;
    border-radius: 50%;
    border: 3px solid #B2B2B2;
    // animation: prixClipFix 2s linear infinite ;
    animation: prixClipFix 2s  infinite ;
  }
  .loader-g::after{
    border-color: #fff;
    animation: prixClipFix 2s linear infinite , rotate 0.5s linear infinite reverse;
    inset: 6px;
  }
  
  @keyframes rotate {
    0%   {transform: rotate(0deg)}
    100%   {transform: rotate(360deg)}
  }
  
  @keyframes prixClipFix {
      0% {clip-path:polygon(50% 50%,50% 0,100% 0,100% 100%,0 100%,0 0)}
      100% {clip-path:polygon(50% 50%,50% 0,100% 0,100% 100%,0 100%,0 0)}
  }
   .cta__mycreditdrive_imgContainer > img{
    width: 100%;
    height: 100%;
    padding-horizontal: 5%;
   }

    .cta__mycreditdrive__modalLaunch__hidden {
      display: none;
    }
    .cta__mycreditdrive__modalLaunch__screen {
      width: 100%;
      /*min-height: 99vh;*/
    }
    /*@media (min-width: 769px) {
      .cta__mycreditdrive__modalLaunch__screen {
        min-height: 99vh;
      }
    }*/
    .cta__mycreditdrive__modalLaunch__button_container {
      background-color: transparent;
      width: "100%";
      height: "100%";
    }

    .cta__mycreditdrive__modalLaunch__modal_container {
      position: fixed;
      left: 0;
      top: 0;
      z-index: 3000;
      display: block;
      background-color: transparent;
      width: 100%;
      height: 100%;
    
    }
    .cta__mycreditdrive__modalLaunch__modal_container.cta__mycreditdrive__modalLaunch__hidden {
      display: none;
    }

    .cta__mycreditdrive__modalLaunch__modal_container_iframe {
      background-color: transparent;
      width: 100%;
      height: 100%;
      border: 0;
    }
    .cta__mycreditdrive__modalLaunch__modal_container_iframe .modal {
      display: block !important;
      opacity: 1 !important;
      background-color: transparent !important;
    }
    @media (max-width: 992px) {
      .cta__mycreditdrive_imgContainer > img {
        width: 100%;
      }
    }
 `;
}

//Function to handle the network request completion
function processCompletedNetworkRequest() {
  //Page is fully loaded, and the network requests are also completed.

  // Look for all launchers (both modal and standalone)
  const buyyerCallWidgetDiv = document.querySelectorAll(
    '.cta__mycreditdrive__modalLaunch'
  );

  let formIndex = 0;
  buyyerCallWidgetDiv.forEach((elem, inx) => {
    if (elem.tagName === 'DIV') {
      const isModal = elem.getAttribute('isModal');
      const gtmid = elem.getAttribute('gtmid');
      const buyyerCallWidgetButton = document.createElement('button');
      const parentDiv = elem.parentNode;

      // Safe JSON parsing with validation
      function safeParseJSON(data) {
        try {
          const parsedData = JSON.parse(data);
          return parsedData && typeof parsedData === 'object' ? parsedData : {};
        } catch (error) {
          console.error("Invalid JSON data:", error);
          return {}; // Return empty object if parsing fails
        }
      }

      // Safely parse attributes
      const customerDetailsRaw = getAttributes(elem, 'customerDetails');
      const customerDetails = customerDetailsRaw ? safeParseJSON(customerDetailsRaw) : {};

      const mycreditdriveInputsRaw = getAttributes(elem, 'mycreditdriveInputs');
      const mycreditdriveInputs = mycreditdriveInputsRaw ? safeParseJSON(mycreditdriveInputsRaw) : {};

      //OF-1859
      const urlParams = new URLSearchParams(window.location.search);
      const overrideMap = {
        autopop_fn:   'firstName',
        autopop_ln:   'lastName',
        autopop_pn:   'phno',
        autopop_em:   'email',
        autopop_addr: 'address',
        autopop_city: 'city',
        autopop_st:   'state',
        autopop_zc:   'zip'
      };
      Object.entries(overrideMap).forEach(([paramKey, jsonField]) => {
        if (urlParams.has(paramKey)) {
          mycreditdriveInputs[jsonField] = urlParams.get(paramKey);
        }
      });

      if (isModal === 'true') {
        elem.style.display = 'none';

        // De-dupe by presence: if the parent already has our launch button, skip.
        // This allows re-adding on filter re-renders that remove the button,
        // while preventing duplicates when the function runs multiple times.
        if (parentDiv &&
            parentDiv.querySelector &&
            parentDiv.querySelector('.cta__mycreditdrive__modalLaunch_buttonLaunch')) {
          return;
        }

        new mycreditdrive({
          parentWebSite: getAttributes(elem, 'parentWebSite'),
          buyyerElement: buyyerCallWidgetButton,
          utmParams: getUTMParameters(getAttributes(elem, 'url')),
          isModal,
          gtmid,
          parentDiv,
          classList: getAttributes(elem, 'classlist'),
          url: getAttributes(elem, 'url'),
          title: getAttributes(elem, 'title'),
          mycreditdriveInputs,
          subTitle: getAttributes(elem, 'subTitle'),
          innerHTML: elem.innerHTML,
          colorPrimary: getAttributes(elem, 'colorPrimary'),
          apiparam: getAttributes(elem, 'apiparam'),
          dcv: getAttributes(elem, 'dcv'),
          rpl: getAttributes(elem, 'rpl'),
          cdsid: getAttributes(elem, 'cdsid'),
          voistock: getAttributes(elem, 'voistock'),
          voiyear: getAttributes(elem, 'voiyear'),
          voimake: getAttributes(elem, 'voimake'),
          voimodel: getAttributes(elem, 'voimodel'),
          voitrim: getAttributes(elem, 'voitrim'),
          voiused: getAttributes(elem, 'voiused'),
          Formid: getAttributes(elem, 'Formid'),
          vin: getAttributes(elem, 'vin'),
          lowestonly: getAttributes(elem, 'lowestonly'),
          template: getAttributes(elem, 'template'),
          additionalParams: getAttributes(elem, 'additionalparams'),
          pic: getAttributes(elem, 'pic'),
          mainmessage: getAttributes(elem, 'mainmessage'),
          validationMessage: getAttributes(elem, 'validationMessage'),
          NoPaymentSuccessMessage: getAttributes(elem, 'NoPaymentSuccessMessage'),
          disclaimer: getAttributes(elem, 'disclaimer'),
          odometer: getAttributes(elem, 'odometer'),
          purchase: getAttributes(elem, 'purchase'),
          msrp: getAttributes(elem, 'msrp'),
          downpayment: getAttributes(elem, 'downpayment'),
          colorSecondary: getAttributes(elem, 'colorSecondary'),
          buttonImgurl: getAttributes(elem, 'button-img-url'),
          customerDetails,
          infoSectionBackground: getAttributes(elem, 'infoSectionBackground'),
          createIframe: true,
          buttonPrimary:
            getAttributes(elem, 'buttonPrimary') ||
            getAttributes(elem, 'buttonprimary') ||
            '#1d328b',
          buttonSecondary:
            getAttributes(elem, 'buttonSecondary') ||
            getAttributes(elem, 'buttonsecondary') ||
            getAttributes(elem, 'button-secondary') ||
            '#1a2c7a',
        });
      } else {
        //for single form
        formIndex++;
        if (formIndex === 1) {
          new mycreditdrive({
            buyyerElement: elem,
            utmParams: getUTMParameters(getAttributes(elem, 'url')),
            isModal,
            gtmid,
            parentDiv,
            classList: getAttributes(elem, 'classList'),
            url: getAttributes(elem, 'url'),
            colorPrimary: getAttributes(elem, 'colorPrimary'),
            apiparam: getAttributes(elem, 'apiparam'),
            dcv: getAttributes(elem, 'dcv'),
            rpl: getAttributes(elem, 'rpl'),
            cdsid: getAttributes(elem, 'cdsid'),
            voistock: getAttributes(elem, 'voistock'),
            voiyear: getAttributes(elem, 'voiyear'),
            voimake: getAttributes(elem, 'voimake'),
            voimodel: getAttributes(elem, 'voimodel'),
            voitrim: getAttributes(elem, 'voitrim'),
            voiused: getAttributes(elem, 'voiused'),
            Formid: getAttributes(elem, 'Formid'),
            vin: getAttributes(elem, 'vin'),
            lowestonly: getAttributes(elem, 'lowestonly'),
            template: getAttributes(elem, 'template'),
            additionalParams: getAttributes(elem, 'additionalparams'),
            pic: getAttributes(elem, 'pic'),
            mainmessage: getAttributes(elem, 'mainmessage'),
            validationMessage: getAttributes(elem, 'validationMessage'),
            NoPaymentSuccessMessage: getAttributes(elem, 'NoPaymentSuccessMessage'),
            disclaimer: getAttributes(elem, 'disclaimer'),
            odometer: getAttributes(elem, 'odometer'),
            purchase: getAttributes(elem, 'purchase'),
            msrp: getAttributes(elem, 'msrp'),
            downpayment: getAttributes(elem, 'downpayment'),
            colorSecondary: getAttributes(elem, 'colorSecondary'),
            buttonPrimary: getAttributes(elem, 'buttonPrimary') || getAttributes(elem, 'buttonprimary'),
            buttonSecondary: getAttributes(elem, 'buttonSecondary') || getAttributes(elem, 'buttonsecondary') || getAttributes(elem, 'button-secondary'),
            infoSectionBackground: getAttributes(elem, 'infoSectionBackground'),
            mycreditdriveInputs: getAttributes(elem, 'mycreditdriveInputs')
              ? JSON.parse(getAttributes(elem, 'mycreditdriveInputs'))
              : {},
            customerDetails: getAttributes(elem, 'customerDetails')
              ? JSON.parse(getAttributes(elem, 'customerDetails'))
              : {},
          });
        }
      }
      createStyles();
    }
  });
}

function getUTMParameters(url) {
  var urlParams = new URLSearchParams(new URL(url).search);
  var utmData = {};

  // Loop through all parameters and filter those starting with "utm_"
  urlParams.forEach((value, key) => {
    key = key.toLowerCase();
    if (key.startsWith('utm_')) {
      utmData[key] = value;
    }
  });
  return utmData;
}

function waitForAscDatalayerAndAttachGTMs(elem) {
  const start = performance.now();
  const maxWait = 60000; //wait
  const interval = 250;

  const check = () => {
    const datalayer = window.asc_datalayer;
    if (datalayer && Array.isArray(datalayer.measurement_ids)) {
      const gtmIds = [...datalayer.measurement_ids];
      const existingAttr = elem.getAttribute('gtmid') || '';
      const existingIds = existingAttr.split(',').map(id => id.trim()).filter(Boolean);
      const combinedIds = [...new Set([...existingIds, ...gtmIds])];
      if (combinedIds.length) {
        elem.setAttribute('gtmid', combinedIds.join(','));
        //console.log('gtmid set:', combinedIds);
      }
    } else if (performance.now() - start < maxWait) {
      setTimeout(check, interval);
    } else {
      console.warn('asc_datalayer.measurement_ids not found');
    }
  };

  check();
}

// OF-1834 init widget on every .cta__mycreditdrive__modalLaunch instance
function initOfferLogixWidget() {
  const targetClassName = 'cta__mycreditdrive__modalLaunch';
  const processedAttr    = 'data-offerlogix-init';

  function handleNewSnippets() {
    let anyNew = false;
    document.querySelectorAll(`.${targetClassName}`)
      .forEach(elem => {
        if (elem.hasAttribute(processedAttr)) return;

        waitForAscDatalayerAndAttachGTMs(elem); 

        elem.setAttribute(processedAttr, 'true');
        anyNew = true;
      });

    if (anyNew) {
      processCompletedNetworkRequest();
    }
  }

  const observer = new MutationObserver(handleNewSnippets);
  observer.observe(document, { childList: true, subtree: true });

  handleNewSnippets();

  // Single GA4 push (optional per-element if you need)
  if (window.dataLayer) {
    const utmParams = getUTMParameters(window.location.href);
    window.dataLayer.push({ event: 'utmParametersCaptured', utmData: utmParams });
  }
}

if (!window._offerLogixWidgetLoaded) {
  window._offerLogixWidgetLoaded = true;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initOfferLogixWidget);
  } else {
    initOfferLogixWidget();
  }

  // Expose for manual/custom‐event init
  window.initOfferLogixWidget = initOfferLogixWidget;
  document.addEventListener('OfferLogixInit', initOfferLogixWidget);
}